/* Add table scrolling  May 29, 2023 */
/* Add color to sort Icon Sep 12, 2024 */
/* Add m_searchMatched,c_searchMode for Front End search Oct 5, 2024 */
/* Add sorting, Add Amend for Performance Dec 21, 2024 */
/* Add table Edit methods Mar 22, 2025 */
/* Fix bug on dueDate sorting, move down sort with valFmtFn Mar 22, 2025 */
<template lang="pug">
	div(class="kt-task-list text-left" :style="c_tblStyle")
		b-table-simple(small hover :style="{'min-width':c_tblMinWidth}")
			b-thead
				b-th(class="th-edit" v-if="p_opts.enableEdit")
				b-th(v-for="col in c_colsVisible" :key="col.key" 
					:class="{'wrap': col.title.length>=20, 'resizing':col.resizing }"
					:style="{'width':col.width}"
				)
					span(@click="m_sortClick(col, $event)") {{col.title}}
					//span(:class="col.sort")
					fa-icon(v-if="col.currentSort==1" icon="arrow-up"  style="color:yellow;")
					fa-icon(v-if="col.currentSort==-1" icon="arrow-down" style="color:#52c1fa;")
					span(class="resizer" @mousedown="m_resizeMD($event, col)")
				b-th
			//- keep v-if below to avoid re-calling functions
			b-tbody(v-if="!d_ktt.d_loading && !d_ktt.d_errMessage")
				b-tr(v-for="(row,ixr) in c_data" :key="ixr" :class="m_trClass(ixr, row)")
					b-td(v-if="p_opts.enableEdit")
						span(v-if="row[d_ktt.c_rec_TaskId] == d_ktt.d_savedId" class="ml-1")
							fa-icon(icon="check" class="text-success")
						b-dropdown(v-else variant="grey1" right lazy=true)
							div(class="dropdown-item" @click="d_ktt.m_editTask(row, ixr)")
								fa-icon(icon="pencil-alt")
								|  Edit
							div(class="dropdown-item" @click="d_ktt.m_cloneTask(row, ixr)")
								fa-icon(icon="copy")
								|  Clone
							div(class="dropdown-item" @click="d_ktt.m_deleteTask(row, ixr)")
								fa-icon(icon="times")
								|  Delete
							template(v-slot:button-content )
								fa-icon(icon="bars")
					b-td(v-for="col in c_colsVisible" :key="col.field" :class="col.readOnly?'disabledClass':col.tdClassFn(row)"  @dblclick="m_dblClickCell($event,col,row,rid,cid)")
						kt-table-column-edit(v-if="m_editColumn(col.field,row) &&!col.readOnly" :p_col="col" :p_recData="row" @change="d_recData=$event" @dblclick="m_dblClickCell($event,col,row,rid,cid)")
						router-link(v-else-if="col.linkFn" :to="col.linkFn(row[col.key])" :class="c_searchMode&&m_searchMatched(row,col.field)?'matched':''") {{d_ktt.m_valFmtTsk(col, row)}}
						span(v-else-if="col.editOnClick" :class="c_searchMode&&m_searchMatched(row,col.field)?'matched':''" class="btn btn-link" @click="d_ktt.m_editTask(row, ixr)") {{row[col.key]}}
						span(v-else :class="c_searchMode&&m_searchMatched(row,col.field)?'matched':''") {{d_ktt.m_valFmtTsk(col, row)}}
					b-td

		//- Loading
		kt-spinner(v-if="d_ktt.d_loading" p_txt="Activities")
		//- Error
		div(v-else-if="d_ktt.d_errMessage" class="error")
			p(class="text-danger") Something went wrong ☹
			p(class="my-1 text-grey5") {{d_ktt.d_errMessage}}	
			p() Please try again or refresh your browser session.
		//- No Data
		div(v-else-if="!c_pdata" class="nodata")
			| No {{d_ktt.c_rec_Activity.slice(0, -1) + "ies"}} found 
			| {{d_ktt.d_dataParams.search? ' matching the searched value':''}}
</template>

 <script>
import {fn_resizeColHelper, fn_saveUserOpts, fn_spliceById,kbdpAlertInfo} from "@/utils/util.js";
import KTTableColumnEdit from "@/components/Ctrl/KT-TableColumnEdit.vue";
export default {
	name: "kt-task-list",
	components: {"kt-table-column-edit":KTTableColumnEdit},
	created() {
	
		console.log('TaskList created');
		console.log(this.p_cols);
	
		if(window.localStorage.getItem(window.location.href+'-sortColumn')){
			var tableSort=JSON.parse(window.localStorage.getItem(window.location.href+'-sortColumn'));
			var colIndex=this.p_cols.findIndex(c=>c.field==tableSort.field);
			var col=this.p_cols[colIndex];
			if(col){
				this.p_cols[colIndex]["currentSort"]=tableSort.sortType;
				this.m_sortClick(col,null);
				}
			}	
	
	},
	data() {
		return {
			d_ktt: this.$parent,
			d_searchMatches:this.p_searchMatches,
			d_searchMode:this.p_searchMode,
			d_cols:this.p_cols,
			d_editColumn:false,
			d_editColumnName:null,
			d_editRowIdx:null,
			d_editRowId:null,
			d_editColumnValue:null,
			d_previousRow:null,
			d_editedColumns:[],
			d_disallowedColumns:['taskAssignees','createdById','createdUTC','updatedBy','updatedUTC'],
			d_qryPrms:this.$parent.d_qryPrms,
		};
	},
	props: {
		p_cols: Array,
		p_data: Array,
		p_opts: {type: Object, default: () => ({})},
		p_dataParams: {type: Object, default: () => ({})},
		p_searchMode:Boolean,
		p_searchMatches:Array,
		p_saveTableEdit:Boolean,
		p_cancelTableEdit:Boolean,
		p_prntAppEnt: Object,
	},
	computed: {
		c_colsVisible() {console.log('p_cols changed'); console.log(this.p_cols);
			return this.d_cols.filter(x => x.visible||x.required);
		},
		c_tblStyle() {
			let sh = this.p_opts.staticHeight;
			if (sh) return `height:${sh}px`;

			let mh = this.p_opts.maxHeight;
			if (mh) return `max-height:${mh}px`;


			//return null;
			return `max-height:490px`;
		},
		c_tblMinWidth() {
			let mw = this.p_opts.width;
			if (mw) return mw;
			let cv = this.c_colsVisible.length;
			if (cv < 4) return null;
			return (cv < 8 ? 500 : cv < 12 ? 800 : 1200) + 'px';
		},
		c_searchMode(){return this.d_ktt.d_searchMode;},
		c_data(){return this.p_data;},
		c_pdata(){return this.p_data||[].length;},
		c_editedColumns(){return this.d_editedColumns.length>0;},
	},
	methods: {
		m_trClass(ixr, row) {
			if (ixr == this.d_ktt.d_editIx) return "kt-in-edit";
			if (row[this.d_ktt.c_rec_TaskId] == this.d_ktt.d_savedId) return "kt-saved";
			return null;
		},
		m_sortClick(col, e) {
		
		var refName;
		var ac;
		var bc;
		var sortType;
		

			if(col["currentSort"])
				sortType=col["currentSort"]*-1;
			else sortType=1;
			
			this.p_cols.forEach(c=>{c["currentSort"]=0;});
			var colIndex=this.p_cols.findIndex(c=>c.field==col.field);
			this.p_cols[colIndex]["currentSort"]=sortType;
	
			var d_data=[...this.p_data];
			

			
				d_data.sort((a, b) => {
				
				/*
				if(col._refId||col._RefData){
				
					//refName=col._refId.replace("Id","Name");
					//ac=a[col.field]?this.d_refData[col._refId].filter(r=>r[col._refId]==a[col.field])[0][refName]:' ';
					//bc=b[col.field]?this.d_refData[col._refId].filter(r=>r[col._refId]==b[col.field])[0][refName]:' ';

				} else 
				if(col._refData){
						//refName=col.field.replace("Id","Name");
						ac=a[col.field]?col._refData.filter(r=>r.id==a[col.field])[0][col._refName]:' ';
						bc=b[col.field]?col._refData.filter(r=>r.id==b[col.field])[0][col._refName]:' ';
						console.log(`ac:${ac} bc:${bc}`);

				} else */
				
				
				
				
				if(col.datatype=='num'||col.datatype=='number') {
							ac = a[col.field]||0;
							bc = b[col.field]||0;
				} else 
						if(col.datatype=='date'||col.field.includes('Date')||col.field.includes('UTC')){
							ac = a[col.field]?new Date(a[col.field]):0;
							bc = b[col.field]?new Date(b[col.field]):0;
				} else 
					if(col.valFmtFn){
						ac=col.valFmtFn(a[col.field]);
						bc=col.valFmtFn(b[col.field]);
				} else {
						ac = a[col.field]?a[col.field].toUpperCase():' ';
						bc = b[col.field]?b[col.field].toUpperCase():' ';
				}
				
					
				if(ac==bc) return 0;
				if(ac<bc) return -1*sortType;
				return 1*sortType;

			});
			this.p_data=[...d_data];
			window.localStorage.setItem(window.location.href+'-sortColumn',JSON.stringify({field:col.field,sortType:sortType*-1}));	
		},
		m_resizeMD(e, col) {
			if (e.button != 0) return;
			if (e.detail > 1) return;

			fn_resizeColHelper(e, col, this.p_opts).then(newWidth => {
				col.width = newWidth;
				let val = {
					_tblW: this.p_opts.width
				};

				this.p_cols.filter(x => x.width).forEach(x => {
					val[x.key] = x.width;
				});
				fn_saveUserOpts(this.d_ktt.d_id, 'tableColumnWidths', val);
			});
		},
		m_searchMatched(row,col){
								row=this.d_ktt.d_searchMatches.filter(s=>s.row==row[this.d_ktt.c_rec_TaskId]&&s.col==col)[0];
								return row?true:false;
								},
		m_dblClickCell(e,col,row,rid,cid){
		
		if(this.m_columnNotEditable(col)) return;
		
		e.preventDefault();
		
		if(this.d_editColumn && col.field==this.d_editColumnName&&
			row[this.d_ktt.c_rec_TaskId]==this.d_editRowId)
			{
				
				var newRow={...row};
				newRow[this.d_editColumnName]=this.d_editColumnValue;
				var rowIdx=this.d_data.findIndex(d=>d[this.d_ktt.c_rec_TaskId]==this.d_editRowId);
				this.d_data.splice(rowIdx,1,newRow);
				
				this.d_editMode=false;
				this.d_editColumn=false;
				this.d_editColumnName=null;
				this.d_editRowId=null;
				this.d_editedRow=null;
				this.d_editedColumns.pop();
				this.$emit('removeEdit',null);
				if(this.d_editedColumns.length==0) window.sessionStorage.removeItem('unsaved-changes');
			return
		} 
			
			if(this.d_editColumn && row[this.d_ktt.c_rec_TaskId] != this.d_editRowNo){						
				kbdpAlertInfo(this,"Save changes","Please Save or Cancel changes before proceeding to a different record.");						
				return						
				}
			if(!this.d_editColumn) this.d_previousRow={...row};
			
			
			this.d_editColumn=true;
			this.d_editColumnName=col.field;
			this.d_editedColumns.push(col.field);
			this.$emit('editTable',col.field);
			this.d_editRowId=row[this.d_ktt.c_rec_TaskId];
			this.d_editColumnValue=row[col.field];
			this.d_editedRowIdx=this.d_data.findIndex(d=>row[this.d_ktt.c_rec_TaskId]==this.d_editRowId);
			window.sessionStorage.setItem('unsaved-changes', true);
		
		},
		m_editColumn(field,row){return this.d_editColumn&&this.d_editColumnName==field&&
						row[this.d_ktt.c_rec_TaskId]==this.d_editRowId;
							},
		m_saveTableEdit() {
			var editedRow=null;
			editedRow=this.d_data.filter(r=>r[this.d_ktt.c_rec_TaskId]==this.d_editRowId)[0];
			if(editedRow) {
				var appEntName=this.d_appEnt.name+ "Task";
				var recId=editedRowId;
				fn_saveRecord(appEntName, recId, editedRow);
				}
			
			this.d_editColumn=false;
			this.d_editColumnName=null;
			this.d_editRowId=null;
			this.d_editedRow=null;
			this.d_editedColumns=new Array();
			window.sessionStorage.removeItem('unsaved-changes');
		
		},
		m_cancelTableEdit(){
		
					
		var rowIdx=this.d_data.findIndex(d=>d[this.d_ktt.c_rec_TaskId]==this.d_editRowId);
		this.d_data.splice(rowIdx,1,this.d_previousRow);
							
		this.d_editColumn=false;
		this.d_editColumnName=null;
		this.d_editRowId=null;
		this.d_editedRow=null;	
        this.d_editedColumns=new Array();
		window.sessionStorage.removeItem('unsaved-changes');				
		
		},
		m_columnNotEditable(col){return this.d_qryPrms.dashboardId||this.d_disallowedColumns.includes(col.field)?true:false;},
	},
	watch:{
		p_cols(nv){
		console.log('TaskList watch');
		console.log(nv);
	
		this.d_cols=nv;
		},
		p_saveTableEdit(nv) {if(nv) this.m_saveTableEdit();},
		p_cancelTableEdit(nv) {if(nv) this.m_cancelTableEditTableEdit();},
	}

};

</script>

<style scoped lang="less">
.kt-task-list {
	font-size: 12.5px;
	overflow-x: auto;

	&:not([style*="height"]) {
		min-height: calc(100vh - 280px);
	}

	> table.b-table {
		border-bottom: solid 0.1em #dee2e6;
		margin-bottom: 1em;
		width: 100%;
		thead {
			background-color: #6c757d;
			color: #fff;
			th {
				padding: 0.2em 0.5em;
				vertical-align: middle;
				white-space: nowrap;
				font-weight: unset;

				position: relative;
				min-width: 60px;
				border-right: solid 0.1em #adb5bd;
				&.wrap {
					white-space: unset;
					min-width: 130px;
				}
				&.th-edit {
					width: 40px;
					min-width: unset;
					border-right: unset;
				}
				&:last-child {
					min-width: unset;
				}
				> span:first-child {
					&:hover {
						cursor: pointer;
						text-decoration: underline;
					}
				}
				> span:nth-child(2) {
					display: inline-block;
					text-align: right;
					width: 10px;
					&.asc::before {
						color:yellow;
						content: " ↑";
					}
					&.desc::before {
						color:#52c1fa;
						content: " ↓";
					}
				}
				> span.resizer {
					position: absolute;
					top: 0em;
					bottom: 0em;
					right: -0.5em;
					width: 1em;
					z-index: 100;
					user-select: none;
					// border: solid 0.1em red;
					&:hover {
						cursor: ew-resize;
					}
				}
				&.resizing {
					border-right-color: #fff;
					> span.resizer {
						width: 20em;
						right: -10em;
						height: 20em;
					}
				}
			}
		}
		tbody {
			tr td:first-child {
				.dropdown-toggle {
					font-size: 0.9em;
					svg {
						color: #4fa4ff;
					}
				}
				.dropdown-item {
					border-bottom: solid 0.1em #ced4da;
					padding: 0.2em 0.5em;
					width: 90px;
					cursor: pointer;
					svg {
						margin-right: 0.4em;
						color: #6c757d;
					}
				}
			}
			tr.kt-in-edit {
				background-color: #e9ecef;
			}
			tr.kt-saved {
				background-color: #e0f0ff;
			}
			tr {
				td span {
					word-break: break-all;
				}
				td.td-usr,
				td.td-dtm {
					font-size: 0.9em;
				}
				td span.btn {
					padding: 0;
					font-size: 1em;
					text-align: unset;
				}
			}
		}
	}
}
table thead {
  padding: 3px;
  position: sticky;
  top: 0;
  z-index: 1;
}
table thead th:nth-child(3) {
  position: sticky!important;
  left: 0;
  z-index: 3;
  background-color:#6c757d;
}
/* make Second Sticky column 
tr > :first-child {
  position: absolute!important; 
}*/
/* make Second Sticky column */
tr > :nth-child(3) {
  position: -webkit-sticky;
  position: sticky!important;
  background:#ffffff;   
  left: 0; 
}
.sticky-div {
  position: -webkit-sticky;
  position: sticky;
  background-color:#ffffff;
  bottom:0;
}
.kt-table-totals{
  position: sticky;
  left: 0;
  z-index: 10;
  background: white;
  width:100%;
}
.kt-table-aggr {
		height: 25px;
		display: flex;
		flex-wrap: wrap;
		font-size: 12.5px!important;
		padding: 0.2em 0;
}
.matched {background-color:yellow; 
		color:black;
		}
td:disabled{
	pointer-events1:none;
	background-color:#e9ecef;    
	border:1px solid white;
	cursor1:not-allowed;
	}
.disabledClass{pointer-events1:none;
			background-color:#e9ecef;    
			border:1px solid white;
			cursor1:not-allowed;
			}
.past-due {
  background: #FDECEA;
  color: #D93025;
  border: 1px solid #F8C7C3;
  border-radius: 4px;
  padding: 2px 6px;
  animation: blink-bg 1s ease-in-out infinite;
}

.due-today1 {
  background: #FFF8E1;
  color: #F9A825;
  border: 1px solid #F3E5AB;
  border-radius: 4px;
  padding: 2px 6px;
}
.due-today {
  background: #E8F5E9;
  color: #2E7D32;
  border: 1px solid #C8E6C9;
  border-radius: 4px;
  padding: 2px 6px;
  animation: pulse 1.2s ease-in-out infinite;
}
.due-soon {
  background: #E8F5E9;
  color: #2E7D32;
  border: 1px solid #C8E6C9;
  border-radius: 4px;
  padding: 2px 6px;
}
.pulse {
  animation: pulse 1.2s ease-in-out infinite;
}

@keyframes pulse {
  0%   { transform: scale(1); }
  50%  { transform: scale(1.08); }
  100% { transform: scale(1); }
}
.blink-bg {
  animation: blink-bg 1s ease-in-out infinite;
}

@keyframes blink-bg {
  0%   { background-color: #FDECEA; }
  50%  { background-color: #ffffff; }
  100% { background-color: #FDECEA; }
}




</style>